(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-guided-consultation"] && !Shopify.designMode) return;
  try {
    
  class VeilConsultation {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('#VeilConsultationContact');
      this.steps = [...root.querySelectorAll('[data-consult-step]')];
      this.current = 0;
      this.next = root.querySelector('[data-consult-next]');
      this.back = root.querySelector('[data-consult-back]');
      this.progress = root.querySelector('[data-consult-progress]');
      this.count = root.querySelector('[data-consult-count]');
      this.bubble = root.querySelector('[data-consult-bubble]');
      this.result = root.querySelector('[data-consult-result]');
      this.objectUrl = null;
      this.next.addEventListener('click', () => this.advance());
      this.back.addEventListener('click', () => this.show(this.current - 1));
      root.querySelector('[data-consult-restart]').addEventListener('click', () => this.restart());
      root.querySelector('[data-consult-print]').addEventListener('click', () => window.print());
      root.querySelector('[data-consult-file]').addEventListener('change', (event) => this.preview(event));
    }
    advance() {
      if (this.current < this.steps.length - 1) this.show(this.current + 1);
      else if (this.form.reportValidity()) this.finish();
    }
    show(index) {
      this.current = index;
      this.steps.forEach((step, i) => { step.hidden = i !== index; });
      this.back.hidden = index === 0;
      this.next.textContent = index === this.steps.length - 1 ? 'See my guidance' : 'Continue';
      this.progress.style.width = `${((index + 1) / this.steps.length) * 100}%`;
      this.count.textContent = `Step ${index + 1} of ${this.steps.length}`;
      this.bubble.textContent = this.steps[index].dataset.bubble;
      this.root.querySelector('[data-consult-guide-name]').textContent = this.steps[index].dataset.guide;
      this.root.querySelector('[data-consult-guide-role]').textContent = this.steps[index].dataset.guideRole;
      this.root.querySelector('.veil-consult__host').animate(
        [{ transform: 'translateY(10px)', opacity: .75 }, { transform: 'translateY(0)', opacity: 1 }],
        { duration: 320, easing: 'ease-out' }
      );
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    preview(event) {
      const file = event.target.files[0];
      const preview = this.root.querySelector('[data-consult-preview]');
      if (this.objectUrl) URL.revokeObjectURL(this.objectUrl);
      preview.replaceChildren();
      if (!file) { preview.hidden = true; return; }
      this.objectUrl = URL.createObjectURL(file);
      const media = file.type.startsWith('video/') ? document.createElement('video') : document.createElement('img');
      media.src = this.objectUrl;
      if (media.tagName === 'VIDEO') media.controls = true;
      media.alt = media.tagName === 'IMG' ? 'Private local preview of selected concern area' : '';
      preview.append(media);
      preview.hidden = false;
    }
    async finish() {
      const sun = [...this.form.querySelectorAll('[data-sun]:checked')].reduce((total, input) => total + Number(input.dataset.sun), 0);
      const moisture = [...this.form.querySelectorAll('[data-moisture]:checked')].reduce((total, input) => total + Number(input.dataset.moisture), 0);
      const clinical = [...this.form.querySelectorAll('[data-clinical]:checked')].reduce((total, input) => total + Number(input.dataset.clinical), 0);
      const finish = this.form.querySelector('[name="finish"]:checked')?.value;
      const concerns = [...this.form.querySelectorAll('[name="concerns"]:checked')].map((input) => input.value);
      const lifestyle = [...this.form.querySelectorAll('[name="lifestyle"]:checked')].map((input) => input.value);
      const hairType = this.form.querySelector('[name="hair_type"]')?.value;
      let friend = { name: 'Kailyn', role: 'Your host', note: 'Kailyn will bring your full story together and review the consultation you sent.' };
      if (concerns.includes('eczema') || concerns.includes('sensitivity')) friend = { name: 'Mei', role: 'The comfort guide', note: 'Mei shares your focus on gentle pacing, ingredient awareness, and thoughtful patch testing.' };
      else if (concerns.includes('marks')) friend = { name: 'Priya', role: 'The even-tone guide', note: 'Priya shares your questions about uneven tone, friction, and realistic ingredient expectations.' };
      else if (hairType && hairType !== 'straight' && hairType !== 'prefer-not') friend = { name: 'Nia', role: 'The hairline and texture guide', note: 'Nia shares your focus on how product texture fits around the neck, hairline, curls, coils, or protective styles.' };
      else if (lifestyle.includes('jogging') || lifestyle.includes('water') || lifestyle.includes('long')) friend = { name: 'Sofia', role: 'The outside guide', note: 'Sofia shares your active-day focus and keeps moisture and sun protection in their proper lanes.' };
      const messages = [];
      if (moisture > 0 && finish !== 'rich') messages.push('<p><strong>For everyday body moisture:</strong> Daily Veil may fit your preference for a soft, lightweight finish. Use it consistently after bathing and whenever skin feels dry.</p>');
      else if (moisture > 0) messages.push('<p><strong>For body moisture:</strong> Daily Veil is a lightweight lotion. If you prefer a very rich finish, start with Daily Veil and decide whether you need a more occlusive layer on especially dry areas.</p>');
      else messages.push('<p><strong>For a simple routine:</strong> Daily Veil can be your everyday body moisturizer when you want softness without a heavy finish.</p>');
      if (sun >= 3) messages.push('<p><strong>For outdoor time:</strong> Daily Veil is not sunscreen. Use a labeled broad-spectrum sunscreen as directed, and choose a water-resistant option when swimming or sweating. Clothing, shade, and timing matter too.</p>');
      else messages.push('<p><strong>For daily sun care:</strong> Daily Veil does not contain SPF. UV exposure can happen in everyday life, so use a labeled broad-spectrum sunscreen as directed when you are exposed.</p>');
      if (clinical > 0) messages.push('<p><strong>For your specific concern:</strong> Acne, eczema, painful irritation, and changes in pigmentation can need individualized professional care. The owner can discuss product experience, but a qualified healthcare professional should evaluate medical concerns.</p>');
      messages.unshift(`<p><strong>Your Kailyn & Friends guide: ${friend.name}</strong> · ${friend.role}<br>${friend.note}</p>`);
      const readValues = (name) => [...this.form.querySelectorAll(`[name="${name}"]:checked`)].map((input) => input.value).join(', ') || 'Not selected';
      const readField = (name) => this.form.querySelector(`[name="${name}"]`)?.value?.trim() || 'Not provided';
      const customerName = readField('contact[name]');
      const receipt = [
        'KADEY’S KREATIONS — GUIDED SKIN PROFILE',
        `Submitted: ${new Date().toLocaleString()}`,
        `Language: ${document.documentElement.lang || 'en'}`,
        '',
        `Name: ${customerName}`,
        `Email: ${readField('contact[email]')}`,
        `Race or ethnicity (optional): ${readField('race')}`,
        `Gender (optional): ${readField('gender')}`,
        `Hair type: ${readField('hair_type')}`,
        `Sun response: ${readValues('sun_response')}`,
        `Outdoor lifestyle: ${readValues('lifestyle')}`,
        `Skin concerns: ${readValues('concerns')}`,
        `Preferred finish: ${readValues('finish')}`,
        `Climate: ${readField('climate')}`,
        `Routine personality: ${readField('routine_personality')}`,
        '',
        `Their skin story:\n${readField('skin_story')}`,
        '',
        `Products currently used:\n${readField('current_products')}`,
        '',
        `Anything else:\n${readField('anything_else')}`,
        '',
        'Customer consented to email delivery for cosmetic product guidance. This profile is not a diagnosis.'
      ].join('\n');
      this.form.querySelector('[data-consult-receipt]').value = receipt;
      const sendStatus = this.root.querySelector('[data-consult-send-status]');
      const receiptStatus = this.root.querySelector('[data-consult-receipt-status]');
      sendStatus.textContent = 'Sending your consultation receipt…';
      this.next.disabled = true;
      let sent = false;
      try {
        const response = await fetch(this.form.action, {
          method: 'POST',
          body: new FormData(this.form),
          headers: { Accept: 'text/html' }
        });
        sent = response.ok;
      } catch (error) {
        sent = false;
      }
      this.root.querySelector('[data-consult-result-copy]').innerHTML = messages.join('');
      this.root.querySelector('[data-consult-result-title]').textContent = `${customerName}, meet your skin profile.`;
      receiptStatus.textContent = sent
        ? 'Your consultation receipt was sent to Kailyn’s store inbox.'
        : 'Your profile is ready, but the email receipt could not be confirmed. Please use the contact link to send it directly.';
      this.form.hidden = true;
      this.root.querySelector('.veil-consult__progress').hidden = true;
      this.count.hidden = true;
      this.result.hidden = false;
      this.bubble.textContent = 'I pulled together your next steps. You can explore the formula, book a conversation, or use the secure upload handoff.';
      this.root.querySelector('[data-consult-guide-name]').textContent = friend.name;
      this.root.querySelector('[data-consult-guide-role]').textContent = friend.role;
      this.result.focus();
      this.next.disabled = false;
    }
    restart() {
      this.form.reset();
      this.form.hidden = false;
      this.root.querySelector('.veil-consult__progress').hidden = false;
      this.count.hidden = false;
      this.result.hidden = true;
      this.root.querySelector('[data-consult-preview]').hidden = true;
      this.root.querySelector('[data-consult-send-status]').textContent = '';
      this.show(0);
    }
  }
  document.querySelectorAll('[data-veil-consult]').forEach((root) => new VeilConsultation(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-ingredient-library"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const libraries = document.querySelectorAll('[data-ingredient-library]');

    libraries.forEach((library) => {
      const index = library.querySelector('[data-ingredient-index]');
      const profileView = library.querySelector('[data-ingredient-profile-view]');
      const profileContent = library.querySelector('[data-ingredient-profile-content]');
      const missing = library.querySelector('[data-ingredient-missing]');
      const passportVoice = library.querySelector('[data-passport-voice]');
      let passportSpeech;
      library.querySelectorAll('[data-passport-speak]').forEach((button) => button.addEventListener('click', () => {
        const transcript = button.dataset.message;
        passportVoice.hidden = false;
        passportVoice.querySelector('[data-passport-speaker]').textContent = `${button.dataset.character} · Ingredient spotlight`;
        passportVoice.querySelector('[data-passport-transcript]').textContent = transcript;
        const status = passportVoice.querySelector('[data-passport-status]');
        if (!('speechSynthesis' in window)) { status.textContent = 'Voice is not supported in this browser. The full transcript is shown here.'; return; }
        window.speechSynthesis.cancel();
        window.speechSynthesis.resume();
        library.querySelectorAll('[data-passport-speak]').forEach((item) => item.classList.remove('is-speaking'));
        passportSpeech = new SpeechSynthesisUtterance(transcript);
        passportSpeech.lang = document.documentElement.lang || 'en-US';
        passportSpeech.rate = .92;
        passportSpeech.volume = 1;
        const language = passportSpeech.lang.split('-')[0];
        const voice = window.speechSynthesis.getVoices().find((item) => item.lang.toLowerCase().startsWith(language));
        if (voice) passportSpeech.voice = voice;
        passportSpeech.onstart = () => { button.classList.add('is-speaking'); status.textContent = 'Playing now…'; };
        passportSpeech.onend = () => { button.classList.remove('is-speaking'); status.textContent = 'Finished. Tap the character to replay.'; };
        passportSpeech.onerror = () => { button.classList.remove('is-speaking'); status.textContent = 'Your phone paused the voice. Turn up media volume and tap again.'; };
        window.speechSynthesis.speak(passportSpeech);
      }));
      passportVoice?.querySelector('[data-passport-stop]').addEventListener('click', () => {
        window.speechSynthesis?.cancel();
        library.querySelectorAll('[data-passport-speak]').forEach((item) => item.classList.remove('is-speaking'));
        passportVoice.hidden = true;
      });

      const getLibraryUrl = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('ingredient');
        return url;
      };

      const searchInput = library.querySelector('[data-ingredient-search]');
      const clearButton = library.querySelector('[data-search-clear]');
      const suggestions = library.querySelector('[data-search-suggestions]');
      const suggestionButtons = library.querySelectorAll('[data-search-suggestion]');
      const filterButtons = library.querySelectorAll('[data-filter]');
      const cards = library.querySelectorAll('[data-ingredient-card]');
      const categorySections = library.querySelectorAll('[data-category-section]');
      const emptyState = library.querySelector('[data-search-empty]');
      const searchStatus = library.querySelector('[data-search-status]');
      let debounceTimer;

      const normalize = (value) => value
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .trim();

      const updateSearchUrl = () => {
        const url = getLibraryUrl();
        const query = searchInput.value.trim();
        const activeFilters = [...filterButtons]
          .filter((button) => button.getAttribute('aria-pressed') === 'true')
          .map((button) => button.dataset.filter);

        if (query) url.searchParams.set('q', query);
        else url.searchParams.delete('q');
        if (activeFilters.length) url.searchParams.set('filters', activeFilters.join(','));
        else url.searchParams.delete('filters');
        window.history.replaceState(window.history.state, '', url);
      };

      const applySearch = (updateUrl = true) => {
        const query = normalize(searchInput.value);
        const activeFilters = [...filterButtons]
          .filter((button) => button.getAttribute('aria-pressed') === 'true')
          .map((button) => button.dataset.filter);
        let visibleCount = 0;

        cards.forEach((card) => {
          const searchText = normalize(card.dataset.searchText || '');
          const filterTags = (card.dataset.filterTags || '').split(',').filter(Boolean);
          const matchesQuery = !query || searchText.includes(query);
          const matchesFilters = activeFilters.every((filter) => filterTags.includes(filter));
          card.hidden = !(matchesQuery && matchesFilters);
          if (!card.hidden) visibleCount += 1;
        });

        categorySections.forEach((section) => {
          const hasResults = [...section.querySelectorAll('[data-ingredient-card]')].some((card) => !card.hidden);
          section.hidden = !hasResults;
          const navItem = library.querySelector(`[data-category-link="${CSS.escape(section.dataset.categorySection)}"]`);
          if (navItem) navItem.hidden = !hasResults;
        });

        clearButton.hidden = !searchInput.value;
        suggestions.hidden = Boolean(searchInput.value);
        emptyState.hidden = visibleCount !== 0;
        searchStatus.textContent = `${visibleCount} ingredient${visibleCount === 1 ? '' : 's'} found`;
        if (updateUrl) updateSearchUrl();
      };

      const scheduleSearch = () => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(() => applySearch(), 160);
      };

      const initialUrl = new URL(window.location.href);
      searchInput.value = initialUrl.searchParams.get('q') || '';
      const initialFilters = (initialUrl.searchParams.get('filters') || '').split(',');
      filterButtons.forEach((button) => {
        button.setAttribute('aria-pressed', initialFilters.includes(button.dataset.filter) ? 'true' : 'false');
        button.addEventListener('click', () => {
          const isActive = button.getAttribute('aria-pressed') === 'true';
          button.setAttribute('aria-pressed', String(!isActive));
          applySearch();
        });
      });

      searchInput.addEventListener('input', scheduleSearch);
      clearButton.addEventListener('click', () => {
        searchInput.value = '';
        applySearch();
        searchInput.focus();
      });
      suggestionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          searchInput.value = button.dataset.searchSuggestion;
          applySearch();
          searchInput.focus();
        });
      });

      const showIndex = () => {
        index.hidden = false;
        profileView.hidden = true;
        missing.hidden = true;
        profileContent.replaceChildren();
        document.title = document.title.replace(/^.+? · /, '');
      };

      const showProfile = (handle, shouldScroll = true) => {
        const template = library.querySelector(`#IngredientProfile-${CSS.escape(handle)}`);

        if (!template) {
          index.hidden = true;
          profileView.hidden = true;
          missing.hidden = false;
          if (shouldScroll) window.scrollTo({ top: 0, behavior: 'smooth' });
          return;
        }

        profileContent.replaceChildren(template.content.cloneNode(true));
        index.hidden = true;
        missing.hidden = true;
        profileView.hidden = false;

        const heading = profileContent.querySelector('h1');
        if (heading) document.title = `${heading.textContent.trim()} · Kadey’s Ingredient Library`;
        if (shouldScroll) window.scrollTo({ top: 0, behavior: 'smooth' });
      };

      const route = (shouldScroll = false) => {
        const handle = new URL(window.location.href).searchParams.get('ingredient');
        if (handle) showProfile(handle, shouldScroll);
        else showIndex();
      };

      library.addEventListener('click', (event) => {
        const ingredientLink = event.target.closest('[data-ingredient-handle]');
        const backLink = event.target.closest('[data-ingredient-library-back]');

        if (ingredientLink) {
          event.preventDefault();
          const handle = ingredientLink.dataset.ingredientHandle;
          const nextUrl = getLibraryUrl();
          nextUrl.searchParams.set('ingredient', handle);
          window.history.pushState({ ingredient: handle }, '', nextUrl);
          showProfile(handle);
        } else if (backLink) {
          event.preventDefault();
          window.history.pushState({}, '', getLibraryUrl());
          showIndex();
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      });

      window.addEventListener('popstate', () => route(true));
      applySearch(false);
      route();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-product-finder"] && !Shopify.designMode) return;
  try {
    
  class KadeysProductFinder {
    constructor(root) {
      this.root = root;
      this.form = root.querySelector('[data-kk-form]');
      this.steps = [...root.querySelectorAll('[data-kk-step]')];
      this.next = root.querySelector('[data-kk-next]');
      this.back = root.querySelector('[data-kk-back]');
      this.results = root.querySelector('[data-kk-results]');
      this.progress = root.querySelector('[data-kk-progress]');
      this.counter = root.querySelector('[data-kk-step-count]');
      this.hint = root.querySelector('[data-kk-hint]');
      this.current = 0;
      this.form.addEventListener('change', () => { this.next.disabled = false; this.hint.textContent = ''; });
      this.next.addEventListener('click', () => this.advance());
      this.back.addEventListener('click', () => this.show(this.current - 1));
      root.querySelector('[data-kk-restart]').addEventListener('click', () => this.restart());
    }
    selected() { return this.steps[this.current].querySelector('input:checked'); }
    advance() {
      if (!this.selected()) { this.hint.textContent = 'Choose an answer to continue.'; return; }
      if (this.current < this.steps.length - 1) this.show(this.current + 1);
      else this.finish();
    }
    show(index) {
      this.current = index;
      this.steps.forEach((step, i) => { step.hidden = i !== index; });
      this.back.hidden = index === 0;
      this.next.textContent = index === this.steps.length - 1 ? 'See my match' : 'Next';
      this.next.disabled = !this.selected();
      this.progress.style.width = `${((index + 1) / this.steps.length) * 100}%`;
      this.counter.textContent = `Question ${index + 1} of ${this.steps.length}`;
      this.steps[index].querySelector('legend').focus?.();
    }
    finish() {
      const scores = [0, 0, 0];
      this.form.querySelectorAll('input:checked').forEach((input) => input.dataset.score.split(',').forEach((score, i) => { scores[i] += Number(score); }));
      const winner = scores.indexOf(Math.max(...scores));
      this.form.hidden = true;
      this.root.querySelector('.kk-finder__progress').hidden = true;
      this.counter.hidden = true;
      this.results.hidden = false;
      this.root.querySelectorAll('[data-kk-match]').forEach((match, i) => { match.hidden = i !== winner; });
      this.results.focus();
    }
    restart() {
      this.form.reset();
      this.form.hidden = false;
      this.root.querySelector('.kk-finder__progress').hidden = false;
      this.counter.hidden = false;
      this.results.hidden = true;
      this.show(0);
      this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
  document.querySelectorAll('[data-kk-finder]').forEach((root) => new KadeysProductFinder(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-product-main"]) return;
  try {
    
  document.querySelectorAll('[data-kadeys-product]').forEach((productSection) => {
    const form = productSection.querySelector('.kk-product__form');
    const variantInput = productSection.querySelector('[data-product-variant]');
    const optionInputs = productSection.querySelectorAll('[data-product-option]');
    const variantsScript = productSection.nextElementSibling;

    if (!form || !variantInput || !optionInputs.length || !variantsScript?.matches('[data-kadeys-variants]')) return;

    const variants = JSON.parse(variantsScript.textContent);
    const price = productSection.querySelector('[data-product-price]');
    const submit = productSection.querySelector('[data-product-submit]');
    const submitLabel = productSection.querySelector('[data-product-submit-label]');

    const updateVariant = () => {
      const selectedOptions = Array.from(optionInputs).map((input) => input.value);
      const variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));

      if (!variant) {
        submit.disabled = true;
        submit.setAttribute('aria-disabled', 'true');
        submitLabel.textContent = 'Unavailable';
        return;
      }

      variantInput.value = variant.id;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(variant.price / 100);
      submit.disabled = !variant.available;
      submit.setAttribute('aria-disabled', String(!variant.available));
      submitLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
  });

  document.querySelectorAll('[data-kadeys-write-review]').forEach((button) => {
    button.addEventListener('click', () => {
      const reviewSection = button.closest('.kk-product-reviews');
      const judgeMeWriteButton = reviewSection?.querySelector('.jdgm-write-rev-link, [data-write-review]');

      reviewSection?.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.setTimeout(() => {
        if (judgeMeWriteButton) {
          judgeMeWriteButton.click();
        } else {
          const widget = reviewSection?.querySelector('#judgeme_product_reviews');
          widget?.focus?.();
        }
      }, 450);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reviewSection = document.querySelector('.kk-reviews');
    if (!reviewSection) return;
    const stopButton = reviewSection.querySelector('[data-review-stop]');
    const reviewSelectors = '.jdgm-rev, .jdgm-carousel-item';
    const enhanceReviews = () => {
      reviewSection.querySelectorAll(reviewSelectors).forEach((review) => {
        if (review.querySelector('[data-review-listen]')) return;
        const body = review.querySelector('.jdgm-rev__body, .jdgm-carousel-item__review-body');
        if (!body?.textContent.trim()) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kk-review-listen';
        button.dataset.reviewListen = '';
        button.textContent = '◖)) Hear Malik read this';
        button.addEventListener('click', () => {
          const author = review.querySelector('.jdgm-rev__author, .jdgm-carousel-item__reviewer-name')?.textContent.trim() || 'a Kadey’s customer';
          const title = review.querySelector('.jdgm-rev__title, .jdgm-carousel-item__review-title')?.textContent.trim() || '';
          const text = body.textContent.trim();
          window.speechSynthesis?.cancel();
          reviewSection.querySelectorAll('[data-review-listen]').forEach((item) => item.classList.remove('is-reading'));
          button.classList.add('is-reading');
          stopButton.hidden = false;
          if ('speechSynthesis' in window) {
            const speech = new SpeechSynthesisUtterance(`Review from ${author}. ${title}. ${text}`);
            speech.lang = document.documentElement.lang || 'en-US';
            speech.onend = () => { button.classList.remove('is-reading'); stopButton.hidden = true; };
            window.speechSynthesis.speak(speech);
          }
        });
        body.insertAdjacentElement('afterend', button);
      });
    };
    stopButton.addEventListener('click', () => {
      window.speechSynthesis?.cancel();
      reviewSection.querySelectorAll('[data-review-listen]').forEach((item) => item.classList.remove('is-reading'));
      stopButton.hidden = true;
    });
    enhanceReviews();
    new MutationObserver(enhanceReviews).observe(reviewSection, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kadeys-veil-launch"] && !Shopify.designMode) return;
  try {
    
  class VeilWorld {
    constructor(root) {
      this.root = root;
      this.guide = root.querySelector('[data-veil-guide]');
      this.button = root.querySelector('[data-veil-guide-button]');
      this.title = root.querySelector('[data-veil-guide-title]');
      this.copy = root.querySelector('[data-veil-guide-copy]');
      this.button.addEventListener('click', () => {
        const closed = this.guide.classList.toggle('is-closed');
        this.button.setAttribute('aria-expanded', String(!closed));
      });
      const observer = new IntersectionObserver((entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        this.title.textContent = visible.target.dataset.guideTitle;
        this.copy.textContent = visible.target.dataset.guideCopy;
        this.guide.classList.remove('is-closed');
        this.button.setAttribute('aria-expanded', 'true');
      }, { threshold: [0.35, 0.6] });
      root.querySelectorAll('[data-guide-title]').forEach((chapter) => observer.observe(chapter));
    }
  }
  document.querySelectorAll('[data-veil-world]').forEach((root) => new VeilWorld(root));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kailyn-and-friends"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-kaf]').forEach((section) => {
      const welcome = section.querySelector('[data-kaf-welcome]');
      const talk = section.querySelector('[data-kaf-talk]');
      const speaker = section.querySelector('[data-kaf-speaker]');
      const message = section.querySelector('[data-kaf-message]');
      const avatar = section.querySelector('[data-kaf-avatar]');
      const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
        if (entry.isIntersecting) entry.target.classList.add('is-visible');
      }), { threshold: .14 });
      section.querySelectorAll('[data-kaf-reveal]').forEach((item, index) => {
        item.style.transitionDelay = `${Math.min(index * 70, 280)}ms`;
        observer.observe(item);
      });
      section.querySelector('[data-kaf-language]')?.addEventListener('change', (event) => event.target.form.submit());
      if (welcome && !sessionStorage.getItem('kafWelcomed')) welcome.showModal();
      welcome?.querySelector('[data-kaf-enter]').addEventListener('click', () => {
        sessionStorage.setItem('kafWelcomed', 'true');
        welcome.close();
        section.querySelector('.kaf__stage').scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      let activeSpeech;
      const speak = (line, button, status) => {
        if (!('speechSynthesis' in window)) {
          if (status) status.textContent = 'Voice playback is not supported in this browser. The complete transcript is shown above.';
          return;
        }
        window.speechSynthesis.cancel();
        window.speechSynthesis.resume();
        activeSpeech = new SpeechSynthesisUtterance(line);
        activeSpeech.lang = document.documentElement.lang || 'en-US';
        activeSpeech.rate = .92;
        activeSpeech.volume = 1;
        const language = activeSpeech.lang.split('-')[0];
        const voice = window.speechSynthesis.getVoices().find((item) => item.lang.toLowerCase().startsWith(language));
        if (voice) activeSpeech.voice = voice;
        activeSpeech.onstart = () => { button?.classList.add('is-speaking'); if (status) status.textContent = 'Playing voice now…'; };
        activeSpeech.onend = () => { button?.classList.remove('is-speaking'); if (status) status.textContent = 'Finished. Tap play to hear it again.'; };
        activeSpeech.onerror = () => { button?.classList.remove('is-speaking'); if (status) status.textContent = 'Your phone paused the voice. Turn up media volume, then tap play again.'; };
        window.speechSynthesis.speak(activeSpeech);
      };
      section.querySelectorAll('[data-kaf-speak]').forEach((button) => button.addEventListener('click', () => {
        const name = button.dataset.name;
        const line = button.dataset.message;
        speaker.textContent = `${name} · ${button.dataset.role}`;
        message.textContent = line;
        avatar.textContent = name.slice(0, 1);
        talk.hidden = false;
        speak(line, button);
      }));
      const spotlight = section.querySelector('[data-kaf-spotlight]');
      section.querySelectorAll('[data-kaf-spotlight-open]').forEach((button) => button.addEventListener('click', () => {
        spotlight.querySelector('[data-kaf-spotlight-name]').textContent = button.dataset.name;
        spotlight.querySelector('[data-kaf-spotlight-identity]').textContent = button.dataset.identity;
        spotlight.querySelector('[data-kaf-spotlight-role]').textContent = button.dataset.role;
        spotlight.querySelector('[data-kaf-spotlight-concern]').textContent = button.dataset.concern;
        spotlight.querySelector('[data-kaf-spotlight-region]').textContent = button.dataset.region;
        spotlight.querySelector('[data-kaf-spotlight-tools]').textContent = button.dataset.tools;
        spotlight.querySelector('[data-kaf-spotlight-story]').textContent = button.dataset.story;
        spotlight.querySelector('[data-kaf-spotlight-message]').textContent = button.dataset.message;
        spotlight.querySelector('[data-kaf-spotlight-image]').style.setProperty('--spotlight-position', `${button.dataset.position}%`);
        spotlight.showModal();
        const playButton = spotlight.querySelector('[data-kaf-spotlight-play]');
        playButton.focus();
        speak(button.dataset.message, playButton, spotlight.querySelector('[data-kaf-audio-status]'));
      }));
      spotlight.querySelector('[data-kaf-spotlight-play]').addEventListener('click', (event) => {
        speak(spotlight.querySelector('[data-kaf-spotlight-message]').textContent, event.currentTarget, spotlight.querySelector('[data-kaf-audio-status]'));
      });
      spotlight.querySelector('[data-kaf-spotlight-close]').addEventListener('click', () => { window.speechSynthesis?.cancel(); spotlight.close(); });
      section.querySelector('[data-kaf-close]').addEventListener('click', () => {
        talk.hidden = true;
        window.speechSynthesis?.cancel();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
